import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Caption from './caption';
import MainContent from './mainContent';

const formatNewsTime = (newsTime) => {
    if (!newsTime) return '';

    return String(newsTime).replace('T', ' ').trim();
};

class Artical extends React.PureComponent {
    static propTypes = {
        type: PropTypes.string,
        topic: PropTypes.string,
        content: PropTypes.object,
        ad: PropTypes.object,
        isHitBlack: PropTypes.bool,
        hasCopyRight: PropTypes.bool,
        sourceReason: PropTypes.string,
        cutoffGray: PropTypes.object,
    };

    isCutoffHandle = () => {
        const {
            cutoffGray,
            isHitBlack,
            content: { wemediaEAccountId },
        } = this.props;

        if (cutoffGray?.cutoffIds?.length > 0) {
            cutoffGray.cutoffIds = cutoffGray.cutoffIds.filter((item) => item.isClose === false) || [];
        }
        const cutoffGrayIds = cutoffGray?.cutoffIds?.map?.((item) => item.id) || [];
        const startTime = new Date(cutoffGray?.startTime).getTime();
        const endTime = new Date(cutoffGray?.endTime).getTime();
        const nowTime = new Date().getTime();
        let isTimeout = false;

        if (nowTime < startTime || nowTime > endTime) {
            isTimeout = true;
        }

        return cutoffGrayIds.includes(wemediaEAccountId) && cutoffGray?.percentage && !isHitBlack && !isTimeout;
    };

    render() {
        const { type, topic, content, ad, cutoffGray } = this.props;
        const {
            title,
            newsTime,
            summery,
            imagesInContent,
            base62Id,
            pcUrl,
            contentData,
            videosPluginData,
            slidesPluginData,
            surveyPluginData,
            goodsPlugin,
            createTime,
            updateTime,
            subscribe,
        } = content;
        const pluginData = {
            videosPluginData,
            slidesPluginData,
            surveyPluginData,
            goodsPlugin,
        };
        const captionData = {
            type,
            title,
            dateTime: formatNewsTime(newsTime),
            subscribe,
            updateTime,
            publishTime: newsTime,
        };

        const shareInfo = {
            url: pcUrl,
            title,
            summery,
            picUrl: imagesInContent && imagesInContent.length > 0 ? imagesInContent[0].url : '',
        };

        const cutofffConfig = {
            createTime,
            base62Id,
            isCutoff: this.isCutoffHandle(),
            cutoffGray: cutoffGray?.percentage || 0,
            filterUA: cutoffGray?.filterUA,
        };

        return (
            <div className={styles.artical}>
                <Caption content={captionData} />
                <MainContent
                    topic={topic}
                    shareInfo={shareInfo}
                    content={contentData}
                    pluginData={pluginData}
                    ad={ad}
                    cutofffConfig={cutofffConfig}
                />
            </div>
        );
    }
}

export default errorBoundary(Artical);
